//
// AUTO-GENERATED FILE. DO NOT MODIFY.
//
// This class was automatically generated by Apollo GraphQL version '4.3.3'.
//
package com.wintermar.inspection.graphql

import com.apollographql.apollo.annotations.ApolloAdaptableWith
import com.apollographql.apollo.api.Adapter
import com.apollographql.apollo.api.CompiledField
import com.apollographql.apollo.api.CustomScalarAdapters
import com.apollographql.apollo.api.Optional
import com.apollographql.apollo.api.Query
import com.apollographql.apollo.api.json.JsonWriter
import com.apollographql.apollo.api.obj
import com.wintermar.inspection.graphql.adapter.InspectionTemplatesQuery_ResponseAdapter
import com.wintermar.inspection.graphql.adapter.InspectionTemplatesQuery_VariablesAdapter
import com.wintermar.inspection.graphql.selections.InspectionTemplatesQuerySelections
import com.wintermar.inspection.graphql.type.InspectionAnswerType
import com.wintermar.inspection.graphql.type.InspectionTemplateStatus
import kotlin.Any
import kotlin.Boolean
import kotlin.Int
import kotlin.String
import kotlin.collections.List
import com.wintermar.inspection.graphql.type.Query as CompiledQuery

public data class InspectionTemplatesQuery(
  public val page: Int,
  public val pageSize: Int,
  public val status: Optional<InspectionTemplateStatus?> = Optional.Absent,
  public val archived: Optional<Boolean?> = Optional.Absent,
) : Query<InspectionTemplatesQuery.Data> {
  override fun id(): String = OPERATION_ID

  override fun document(): String = OPERATION_DOCUMENT

  override fun name(): String = OPERATION_NAME

  override fun serializeVariables(
    writer: JsonWriter,
    customScalarAdapters: CustomScalarAdapters,
    withDefaultValues: Boolean,
  ) {
    InspectionTemplatesQuery_VariablesAdapter.serializeVariables(writer, this, customScalarAdapters, withDefaultValues)
  }

  override fun adapter(): Adapter<Data> = InspectionTemplatesQuery_ResponseAdapter.Data.obj()

  override fun rootField(): CompiledField = CompiledField.Builder(
    name = "data",
    type = CompiledQuery.type
  )
  .selections(selections = InspectionTemplatesQuerySelections.__root)
  .build()

  @ApolloAdaptableWith(InspectionTemplatesQuery_ResponseAdapter.Data::class)
  public data class Data(
    public val inspectionTemplates: InspectionTemplates,
  ) : Query.Data

  public data class InspectionTemplates(
    public val `data`: List<Data1>?,
    public val totalCount: Int,
  )

  public data class Data1(
    public val id: Any,
    public val name: String,
    public val status: InspectionTemplateStatus,
    public val version: Int,
    public val publishedDate: Any?,
    public val parentId: Any?,
    public val numberOfPages: Int?,
    public val numberOfSections: Int?,
    public val numberOfQuestions: Int?,
    public val pages: List<Page>,
  )

  public data class Page(
    public val id: Any,
    public val templateId: Any,
    public val order: Int,
    public val title: String,
    public val sections: List<Section>,
  )

  public data class Section(
    public val id: Any,
    public val pageId: Any,
    public val order: Int,
    public val title: String,
    public val questions: List<Question>,
  )

  public data class Question(
    public val id: Any,
    public val sectionId: Any,
    public val questionText: String,
    public val guidelines: String?,
    public val required: Boolean,
    public val order: Int,
    public val answerType: InspectionAnswerType,
    public val failedOptionId: Any?,
    public val neutralOptionId: Any?,
  )

  public companion object {
    public const val OPERATION_ID: String =
        "a523d342c31a5f4b80120e478c57330731a6dc7a84610046382a3221050be73e"

    /**
     * The minimized GraphQL document being sent to the server to save a few bytes.
     * The un-minimized version is:
     *
     * ```
     * query inspectionTemplates($page: Int!, $pageSize: Int!, $status: InspectionTemplateStatus, $archived: Boolean) {
     *   inspectionTemplates(query: {
     *     page: $page
     *     pageSize: $pageSize
     *     status: $status
     *     archived: $archived
     *   }
     *   ) {
     *     data {
     *       id
     *       name
     *       status
     *       version
     *       publishedDate
     *       parentId
     *       numberOfPages
     *       numberOfSections
     *       numberOfQuestions
     *       pages {
     *         id
     *         templateId
     *         order
     *         title
     *         sections {
     *           id
     *           pageId
     *           order
     *           title
     *           questions {
     *             id
     *             sectionId
     *             questionText
     *             guidelines
     *             required
     *             order
     *             answerType
     *             failedOptionId
     *             neutralOptionId
     *           }
     *         }
     *       }
     *     }
     *     totalCount
     *   }
     * }
     * ```
     */
    public val OPERATION_DOCUMENT: String
      get() = "query inspectionTemplates(${'$'}page: Int!, ${'$'}pageSize: Int!, ${'$'}status: InspectionTemplateStatus, ${'$'}archived: Boolean) { inspectionTemplates(query: { page: ${'$'}page pageSize: ${'$'}pageSize status: ${'$'}status archived: ${'$'}archived } ) { data { id name status version publishedDate parentId numberOfPages numberOfSections numberOfQuestions pages { id templateId order title sections { id pageId order title questions { id sectionId questionText guidelines required order answerType failedOptionId neutralOptionId } } } } totalCount } }"

    public const val OPERATION_NAME: String = "inspectionTemplates"
  }
}
